import { useState } from 'react';
import { Button } from 'primereact/button';
import { DataTableFilterMeta, DataTableFilterMetaData } from 'primereact/datatable';

export function activeFilterCount(filters: DataTableFilterMeta): number {
    const hasValue = (value: unknown) => value !== null && value !== undefined
        && (typeof value !== 'string' || value.trim() !== '') && (!Array.isArray(value) || value.length > 0);
    return Object.values(filters).filter(filter => 'constraints' in filter
        ? filter.constraints.some(constraint => hasValue(constraint.value)) : hasValue(filter.value)).length;
}

export function useListFilters(fields: Record<string, DataTableFilterMetaData['matchMode']>) {
    const initialFilters = (): DataTableFilterMeta => Object.fromEntries(Object.entries(fields).map(([field, matchMode]) =>
        [field, { operator: 'and', constraints: [{ value: null, matchMode }] }]));
    const [filters, setFilters] = useState<DataTableFilterMeta>(initialFilters);
    return { filters, setFilters, count: activeFilterCount(filters), clear: () => setFilters(initialFilters()) };
}

export function ListFilterStatus({ count, onClear }: { count: number; onClear: () => void }) {
    if (!count) return null;
    return <div className="list-filter-status">
        <span role="status"><i className="pi pi-filter-fill" aria-hidden="true" /> {count} active {count === 1 ? 'filter' : 'filters'}</span>
        <Button label="Clear filters" icon="pi pi-filter-slash" className="p-button-text p-button-sm" onClick={onClear} />
    </div>;
}

export function ListEmptyState({ filtered, empty, noMatches, onClear }: {
    filtered: boolean; empty: string; noMatches: string; onClear: () => void;
}) {
    return <div className="list-empty-state">
        <i className={`pi ${filtered ? 'pi-search' : 'pi-info-circle'}`} aria-hidden="true" />
        <span>{filtered ? noMatches : empty}</span>
        {filtered && <Button label="Clear filters" icon="pi pi-filter-slash" className="p-button-text p-button-sm" onClick={onClear} />}
    </div>;
}
